import Vue from 'vue'
import Vuex from 'vuex'
import haier from './haier'

Vue.use(Vuex)

export default new Vuex.Store({
	modules:{
		common:{
			state:{
				info:{},
			},
			mutations:{
				/*设置个人信息*/
				setUserInfo (state,info) {
					if(info){
						// let copy  = {}
						// for(var i in state.info){
						// 	copy[i] = state.info[i]
						// }
						let copy = Object.assign({},state.info)
						for(var i in info) {
							copy[i] = info[i];
						}
						state.info = copy;
					}else{
						state.info = {}
					}
				},
				setUserInfoAll (state,info){
					state.info = info;
				},
			},
		},
		haier
	}
})


// WEBPACK FOOTER //
// ./src/store/index.js